import React, { useState, useCallback } from "react";
import FooterHomePage from "../../components/footerHomePage/footerHomePage";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import axios from "axios";
import Swal from "sweetalert2";
import "./UploadBundlesLealtad.css";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import LoaderExcel from "../../components/LoaderExcel/LoaderExcel";
import LogoPDF from "../../../assets/imagePDF/pdf.png";
import { TiDelete } from "react-icons/ti";

const UploadBundle = () => {
  const navigate = useNavigate();
  const [bundles, setBundles] = useState([]);
  const [loaderBundle, setLoaderBundle] = useState(false);
  const [clickButton, setClickButton] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles?.length) {
      const validFiles = acceptedFiles.filter((file) => {
        const fileNameWithoutExtension = file.path.replace(".pdf", "");
        const parts = fileNameWithoutExtension.split("-");
        const fileNameLegajo = parts[0];

        const isValidName = /^\d{11}$/.test(fileNameLegajo);

        // Validar que el tamaño del archivo no supere 1 MB
        const maxSizeMB = 1;
        const fileSizeMB = file.size / (1024 * 1024); // Convertir bytes a megabytes
        const isValidSize = fileSizeMB <= maxSizeMB;

        if (!isValidName) {
          Swal.fire({
            icon: "error",
            title: "El archivo fue excluido",
            text: `El archivo ${fileNameLegajo} no tiene los 11 dígitos.`,
          });
        } else if (!isValidSize) {
          Swal.fire({
            icon: "error",
            title: "El archivo fue excluido",
            text: `El archivo ${file.name} excede el tamaño máximo permitido de ${maxSizeMB} MB.`,
          });
        }

        return isValidName && isValidSize;
      });

      setBundles((previousFiles) => [
        ...previousFiles,
        ...validFiles.map((file) =>
          Object.assign(file, { preview: URL.createObjectURL(file) })
        ),
      ]);
    }
  }, []);

  //SE BORRAN LOS ARCHIVOS SELECIONADOS
  const removeFile = (name) => {
    setBundles((files) => files.filter((file) => file.name !== name));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  //SE SUBEN LOS ARCHIVOS CON EL BOTON
  const UploadBundles = async (event) => {
    try {
      event.preventDefault();
      setClickButton(true);

      const endpoint = `${process.env.REACT_APP_LEALTAD_LEGAJO}`;
      setLoaderBundle(true);

      // Crear FormData y agregar archivos válidos
      const formData = createFormData(bundles);

      // Realizar la solicitud con el FormData que contiene solo los archivos válidos
      const res = await axios.post(endpoint, formData);

      // Manejar la respuesta exitosa
      handleSuccess(res);
      // Volviendo al Inicio
      navigate("/inicio-lealtad");
    } catch (error) {
      // Manejar errores
      handleError();
    } finally {
      // Restablecer estados independientemente del resultado
      setClickButton(false);
      setLoaderBundle(false);
    }
  };

  // Función para crear FormData y agregar archivos válidos
  const createFormData = (validBundles) => {
    const formData = new FormData();

    validBundles.forEach((file) => {
      const fileNameWithoutExtension = file.path.replace(".pdf", "");
      const parts = fileNameWithoutExtension.split("-");
      const cuil = parts[0];
      const credit = parts[1];

      formData.append("document", file);
      formData.append("cuil", cuil);
      formData.append("credit", credit);
    });

    return formData;
  };

  // Función para manejar la respuesta exitosa
  const handleSuccess = (res) => {
    const legajoCheck = res.data.userCheckFailed;

    let message = "<p>Documentos y Legajos creados correctamente.</p>";
    if (legajoCheck.length > 0) {
      message += "<p>Los siguientes legajos no se encontraron por CUIL:</p>";
      message += "<ul>";
      legajoCheck.forEach((legajo) => {
        message += `<li>Nombre original: ${legajo.originalname}</li>`;
      });
      message += "</ul>";
    }

    Swal.fire({
      icon: "success",
      title: "Éxito",
      html: message,
    });
  };

  // Función para manejar errores
  const handleError = () => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Parece que hubo un error al tratar de cargar los archivos",
    });
  };

  return (
    <div className="heighmaxhv">
      <HeaderLogoIcon />
      <div className="UploadBundles" {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p className="textinputbundles">Suelta los archivos aquí ...</p>
        ) : (
          <p className="textinputbundles">
            Arrastre y suelte algunos archivos aquí o haga clic para seleccionar
            archivos
          </p>
        )}
      </div>
      {loaderBundle !== false ? <LoaderExcel /> : null}

      <div className="galleriBundles">
        <ul className="boxGalery">
          {bundles.map((file) => (
            <div key={file.name}>
              <li>
                <TiDelete
                  className="iconDeletePDF"
                  onClick={() => removeFile(file.name)}
                />
                <img
                  src={LogoPDF}
                  alt="logopdf"
                  className="imageGaleryBundle"
                />
              </li>
              <p className="fileNamePDF">{file.name}</p>
            </div>
          ))}
        </ul>
      </div>

      {clickButton !== true ? (
        <div className="boxBundles">
          <button
            className="buttonBundle-lealtad"
            onClick={(event) => UploadBundles(event)}
          >
            Subir Legajos
          </button>
        </div>
      ) : null}

      <FooterHomePage />
    </div>
  );
};

export default UploadBundle;
